mutation GenerateSalesforceCasesForPeriod($periodId: ID!) {
  generateSalesforceCasesForPeriod(input: { periodId: $periodId }) {
    success
  }
}
